import React, { forwardRef } from 'react';
const Overlay = forwardRef(function Overlay({ testId = 'store-overlay', ...otherProps }, ref) {
    return (React.createElement("div", Object.assign({ role: "presentation", "data-store-overlay": true, "data-testid": testId, ref: ref }, otherProps)));
});
export default Overlay;
//# sourceMappingURL=Overlay.js.map